import _ from 'lodash';
import moment from 'moment';
import * as ActionTypes from "../actions/index";
import {LOCATION_CHANGE} from "connected-react-router";
import { arrayUnique } from '../helpers/questions/functions';
import { NAME_FIELD } from '../helpers/constants';

const defaultState = {
    questions: [],
    fetching: false,
    formData: {},
    initialFormData: {},
    featuredQuestions: [],
    initialFeaturedQuestions: [],
    posting: false,
    postingRequestUpdate: false,
    attachments: [],
    badResponse: '',
    badMsg: '',
    tags: '',
    msg: '',
    uploadLabel: 'Drag and drop.',
    notValidMail: '',
    updatePolicy: {},
    previousUpdates: [],
    selectedPreviousUpdate: {},
    openModal: false,
    usersRequestUpdateCheckBox: false,
    sendEmailNotification: false,
    failedToGetLastUpdateMsg: '',
    failedToGetQuestions: '',
    fetchingLastUpdate: false,
    fetchingAllPreviousUpdates: false,
    tagsDescription: '',
    fetchingTagsDescription: false,
    fetchingCostsSummary: false,
    costsSummary:'',
    costsSummaryError:'',
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.PREPOPULATE_UPDATE_FORM_FIELD:
            const question = _.find( state.questions, question => {
                return question.machineName === action.payload.questionMachineName
            });
            if(!question) {return state;}
            return {
                ...state,
                formData: {
                    ...state.formData,
                    [question.id]: action.payload.value
                }
            };
        case ActionTypes.GET_UPDATE_TAB_TAGS_DESCRIPTION:
            return {
                ...state,
                fetchingTagsDescription: true
            };
        case ActionTypes.GET_UPDATE_TAB_TAGS_DESCRIPTION_SUCCESS:
            let tagsDes;
            try {
                tagsDes = action.payload.body.body;
            }
            catch (e){ tagsDes = ''}
            return {
                ...state,
                fetchingTagsDescription: false,
                tagsDescription: tagsDes
            };
        case ActionTypes.GET_UPDATE_TAB_TAGS_DESCRIPTION_FAIL:
            return {
                ...state,
                fetchingTagsDescription: false
            };
        case ActionTypes.REQUEST_GET_ALL_PREVIOUS_UPDATES:
            return {
                ...state,
                fetchingAllPreviousUpdates: true
            };
        case ActionTypes.RECEIVE_GET_ALL_PREVIOUS_UPDATES:
            let updates = [];
            if (action.payload !== null) {
                updates = action.payload
            }
            return {
                ...state,
                previousUpdates: updates,
                fetchingAllPreviousUpdates: false
            };
        case ActionTypes.FAILED_TO_RECEIVE_ALL_PREVIOUS_UPDATES:
            return {
                ...state,
                fetchingAllPreviousUpdates: false
            };
        case ActionTypes.REQUEST_GET_LAST_UPDATE_POLICY_FORM:
            return {
                ...state,
                fetchingLastUpdate: true
            };
        case ActionTypes.RECEIVE_GET_REQUEST_LAST_UPDATE_POLICY_FORM:
            if(!action.payload) return {...state, fetchingLastUpdate: false};
            let attachments = [];
            let tags = '';
            let uploadLabel = 'Drag and drop.';
            let formDataApp = _.mapValues(_.keyBy(action.payload.policyUpdateAnswersDtos , 'questionId'), (dto, key) => {
                if(dto.date) return new Date(dto.date);
                if(dto.amount) return dto.amount;
                if(dto.text) return dto.text;
                if(dto.optionId) return dto.optionId;
                return ''
            });
            if (action.payload.attachments != null && action.payload.attachments.length > 0) {
                attachments = action.payload.attachments;
                tags = action.payload.attachments[0].tags || '';
            }
            return {
                ...state,
                updatePolicy: action.payload,
                formData: Object.keys(formDataApp).length > 0 ? formDataApp : state.initialFormData,
                attachments: attachments,
                tags: tags,
                uploadLabel: uploadLabel,
                fetchingLastUpdate: false
            };
        case ActionTypes.FAILED_TO_RECEIVE_LAST_UPDATE_POLICY_FORM:
            return {
                ...state,
                failedToGetLastUpdateMsg: 'Failed to get last update. Please try again later.',
                fetchingLastUpdate: false
            };
        case ActionTypes.REQUEST_GET_UPDATE_QUESTIONS:
            return {
                ...state,
                fetching: true
            };
        case ActionTypes.RECEIVE_GET_UPDATE_QUESTIONS:
            if(!action.payload) return {...state, fetching: false};
            let formData = _.mapValues(_.keyBy(action.payload , 'id'), (i, key) => state.formData[key]?state.formData[key]:'');
            return {
                ...state,
                fetching: false,
                questions: action.payload,
                formData: formData,
                initialFormData: formData,
                attachments: [],
                tags: ''
            };
        case ActionTypes.FAILED_TO_RECEIVE_UPDATE_QUESTIONS:
            let failedToGetQuestionsMsg = '';
            try {
                failedToGetQuestionsMsg = action.payload.response.body.message
            } catch (e) {
                failedToGetQuestionsMsg = 'Failed to receive update questions. Please try again later.'
            }
            return {
                ...state,
                fetching: false,
                failedToGetQuestions: failedToGetQuestionsMsg
            };
        case ActionTypes.CHANGE_UPDATE_POLICY_FIELD:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case ActionTypes.CHANGE_UPDATE_POLICY_FORM_DATA:
            return {
                ...state,
                formData: {...state.formData, [action.payload.key]: action.payload.value},
                badMsg: '',
                badResponse: '',
                notValidMail: '',
                msg: ''
            };
        case ActionTypes.REQUEST_POST_UPDATE_POLICY_FORM:
            // Check if it's a Request Update (User role) by checking for sendEmail property
            const isRequestUpdate = action.payload && action.payload.hasOwnProperty('sendEmail');
            return {
                ...state,
                posting: !isRequestUpdate,
                postingRequestUpdate: isRequestUpdate,
                msg:'',
                badMsg:'',
            };
        case ActionTypes.REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM:
            return {
                ...state,
                posting: true
            };
        case ActionTypes.RECEIVE_POST_UPDATE_POLICY_FORM:
            if (action.payload !== null)
                return {
                    ...state,
                    posting: false,
                    postingRequestUpdate: false,
                    msg: 'Updated Successfully.',
                    previousUpdates: [action.payload, ...state.previousUpdates]
                };
            else return {
                ...state,
                posting: false,
                postingRequestUpdate: false,
                msg: 'Request made successfully.',
                sendEmailNotification: false
            };
        case ActionTypes.RECEIVE_POST_NO_CHANGES_UPDATE_POLICY_FORM:
            return {
                ...state,
                posting: false,
                msg: 'Updated Successfully.',
            };
        case ActionTypes.GET_COSTS_SUMMARY:
            return {
                ...state,
                fetchingCostsSummary: true,
            };
        case ActionTypes.RECEIVE_COSTS_SUMMARY:
            return {
                ...state,
                costsSummary: action.payload,
                fetchingCostsSummary: false,
            };
        case ActionTypes.FAILED_TO_GET_COSTS_SUMMARY:
            var error = '';
            try {
                error = action.payload.response.body.message;
            }
            catch (e) {
                error = "Could not calculate costs summary, please try again later"
            }
            return {
                ...state,
                costsSummaryError: error,
                fetchingCostsSummary: false,
            };
        case ActionTypes.RECEIVE_BAD_REQUEST_POST_UPDATE_POLICY_FORM:
            return {
                ...state,
                posting: false,
                postingRequestUpdate: false,
                badMsg: action.payload,
                badResponse: action.payload,
                sendEmailNotification: false
            };
        case ActionTypes.RECEIVE_BAD_REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM:
            return {
                ...state,
                posting: false,
                badMsg: action.payload,
                badResponse: action.payload
            };
        case ActionTypes.UPDATE_POLICY_ATTACHMENTS_CHANGE: {
            const newAttachments = arrayUnique([...state.attachments, action.payload], NAME_FIELD);
            return {
                ...state,
                attachments: newAttachments,
                uploadLabel: defaultState.uploadLabel,
                tags: defaultState.tags
            }
        }
        case ActionTypes.CHANGE_ACTIVE_TAB:
            return {
                ...state,
                msg: '',
                badMsg: '',
                sendEmailNotification: defaultState.sendEmailNotification
            };
        case ActionTypes.LOGOUT:
            return {
                ...defaultState
            };
        case LOCATION_CHANGE:
            return defaultState
        default :
            return state
    }
}